import React, { useState, useEffect } from 'react';
import { string, arrayOf, shape, bool, object } from 'prop-types';

import { Image } from 'nordic/image';

import IconFull from '../../../../components-v2/icons/sources/full';
import IconFullSuper from '../../../../components-v2/icons/sources/full-super';
import IconFullSuperMlb from '../../../../components-v2/icons/sources/full-super-mlb';
import Pills from '../pills';

const Title = ({
  devices,
  text,
  picture,
  pills,
  values,
  group_by,
  shouldRenderIcons = true,
  nameSpace,
  currentInterventionData,
  promotedLink,
}) => {
  const [pillsData, setPillsData] = useState(pills);
  const namespace = `${nameSpace}__content`;

  const isPadIntervention = group_by === 'PADS_INTERVENTION';

  const renderPills = () => {
    if (!pillsData?.length) {
      return null;
    }

    return (
      <div className={`${namespace}-options`}>
        {pillsData.map((pill) => (
          <Pills {...pill} key={pill.text} />
        ))}
      </div>
    );
  };

  const renderTextWithIcons = () =>
    text.split(' ').map((word) => {
      switch (word) {
        case '{main_text}':
          return (
            <span key={word} className={`${namespace}-main-text`}>
              {values[0].text}{' '}
            </span>
          );
        case '{full_cart}':
          return <IconFull key={word} />;
        case '{full_super}':
          return <IconFullSuper key={word} />;
        case '{full_super_mlb}':
          return <IconFullSuperMlb key={word} />;
        case '{promoted_text}':
          return '';

        default:
          return `${word} `;
      }
    });

  useEffect(() => {
    if (currentInterventionData?.id === group_by) {
      if (currentInterventionData?.header?.progress_bar?.percent > 0) {
        setPillsData([]);
      } else if (!currentInterventionData?.header?.progress_bar && currentInterventionData?.header?.pills) {
        setPillsData(currentInterventionData?.header?.pills);
      } else {
        setPillsData(pills);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentInterventionData]);

  return (
    <div className={namespace}>
      {picture && devices && (
        <div className={`${namespace}-brand-image`}>
          <Image src={picture} alt={text} lazyload="on" className="image" />
        </div>
      )}
      {isPadIntervention && shouldRenderIcons && renderPills()}
      <span className={`${namespace}-title ${namespace}-title${picture && devices ? '--w-80' : '--w-100'}`}>
        {renderTextWithIcons()}
      </span>
      {isPadIntervention &&
        (promotedLink ? (
          <a href={promotedLink} className={`${namespace}-promoted-text`}>
            {values[0].text}
          </a>
        ) : (
          <span className={`${namespace}-promoted-text`}>{values[0].text}</span>
        ))}
      {!isPadIntervention && shouldRenderIcons && renderPills()}
    </div>
  );
};

Title.propTypes = {
  currentInterventionData: shape({
    id: string,
    header: shape({
      progress_bar: object,
      pills: arrayOf(
        shape({
          accessibility_text: string,
          color: bool,
          text: string,
          values: arrayOf(
            shape({
              id: string,
            }),
          ),
        }),
      ),
    }),
  }),
  devices: bool,
  group_by: string,
  nameSpace: string,
  picture: string,
  pills: arrayOf(
    shape({
      accessibility_text: string,
      color: bool,
      text: string,
      values: arrayOf(
        shape({
          id: string,
        }),
      ),
    }),
  ),
  promotedLink: string,
  shouldRenderIcons: bool,
  text: string,
  values: arrayOf(
    shape({
      text: string,
    }),
  ),
};

export default Title;
